import React, { useCallback, useEffect, useState } from "react";
import { Tables } from "../../components/Elements/Tables/Tables";
import { ReactComponent as BackIcon } from "../../assets/svgs/back-square.svg";
import { SearchBar } from "../../components/Elements/Search/SearchBar";
import { EyeOutlined } from "@ant-design/icons";
import { Button } from "antd";
import TextStyles from "../../components/Elements/TextStyles/TextStyles";
import { useLocation, useNavigate } from "react-router-dom";
import { getApi } from "../../api/api_instance";
import { API_URLS } from "../../api/apiUrls";
import toast from "react-hot-toast";
import useDebounce from "../../hooks/debouncing";

const SubSections = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { sectionId, subSectionName } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [tableData, setTableData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const debouncedSearch = useDebounce(searchTerm, 500);
  const fetchSubSections = useCallback(async () => {
    if (!sectionId) return;
    try {
      setLoading(true);

      const response = await getApi({
        apiUrl: API_URLS.SUBSECTION_BY_ID(
          sectionId,
          currentPage,
          pageSize,
          debouncedSearch
        ),
      });

      if (response.success) {
        console.log("sec:details of records", sectionId);
        setTotalRecords(response?.total || 0);
        const data = Array.isArray(response?.data) ? response.data : [];

        const formattedData = data.map((item, index) => ({
          key: item._id,
          serial: (currentPage - 1) * pageSize + index + 1,
          sub_section: item.name || "-",
          totalQuestion: item.totalQuestions || 0,
          action: (
            <EyeOutlined
              style={{ fontSize: "18px", cursor: "pointer" }}
              onClick={() => {
                navigate(`/question-bank/sub-section/${item.id}`, {
                  state: {
                    subSectionId: item.id,
                    subSectionName: item.name,
                    totalQuestions: item.totalQuestions,
                    section: sectionId,
                  },
                });
              }}
            />
          ),
        }));

        setTableData(formattedData);
      } else {
        setTableData([]);
      }
    } catch (err) {
      console.error("Error fetching subsections", err);
      toast.error("Failed to fetch subsections");
      setTableData([]);
    } finally {
      setLoading(false);
    }
  }, [currentPage, pageSize, sectionId, debouncedSearch, navigate]);

  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  useEffect(() => {
    fetchSubSections();
    console.log("sectionId is :", sectionId);
  }, [fetchSubSections]);

  const headers = [
    { label: "Sr. No.", key: "serial" },
    { label: "Sub-Section Name", key: "sub_section" },
    { label: "Total Questions", key: "totalQuestion" },
    { label: "Action", key: "action" },
  ];

  return (
    <div
      style={{ backgroundColor: "#fff" }}
      className="h-screen px-[20px]"
    >
      <div className="flex justify-end text-xs font-light p-3">
        <p>Home</p>
        <span>/</span>
        <p>My Question Bank</p>
        <span>/</span>
        <TextStyles color="gradient">Sub Sections</TextStyles>
      </div>
      <div className="flex items-center gap-2 text-xl font-bold mb-5">
        <BackIcon
          onClick={() => navigate(-1)}
          className="cursor-pointer"
        />
        <TextStyles color="gradient">
          {subSectionName || "Sub Sections"}
        </TextStyles>
      </div>

      <div
        style={{
          border: "1px solid #3BA2B959",
          borderRadius: "10px",
          paddingTop: "20px",
          boxShadow: "0px 0px 16px 0px #3BA2B91F",
        }}
      >
        <div className="flex gap-4 pl-3">
          <p className="px-8  h-[42px] flex items-center justify-center border border-[#06513D] bg-[#B6D4D933] rounded-md text-[#06513D] text-base font-light">
            TOTAL SUB SECTION {totalRecords}
          </p>

          <SearchBar
            width="300px"
            onSearch={(value) => setSearchTerm(value)}
          />
        </div>

        <div className="px-2">
          <Tables
            data={tableData}
            headers={headers}
            loading={loading}
            current={currentPage}
            onChange={handlePageChange}
            total={totalRecords}
            pageSize={pageSize}
          />
        </div>
      </div>
    </div>
  );
};

export default SubSections;
